import React, { useState } from 'react';
import { Pill } from 'lucide-react';
import logoImage from '../assets/images/logo_farmacia_branca.png';

const LogoVertical = ({ size = 'medium', color = '#007bff' }) => {
  const [imageError, setImageError] = useState(false);
  
  const sizes = {
    small: { icon: 40, font1: '12px', font2: '10px' },
    medium: { icon: 56, font1: '16px', font2: '14px' },
    large: { icon: 72, font1: '24px', font2: '22px' },
    xlarge: { icon: 88, font1: '28px', font2: '26px' }
  };

  const currentSize = sizes[size] || sizes.medium;

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      gap: '8px',
      textAlign: 'center'
    }}>
      {/* Logo da farmácia */}
      {!imageError ? (
        <img 
          src={logoImage} 
          alt="Farmácia Popular de Minas" 
          style={{ 
            width: `${currentSize.icon}px`, 
            height: 'auto',
            maxHeight: `${currentSize.icon}px`,
            objectFit: 'contain'
          }}
          onError={() => setImageError(true)}
        />
      ) : (
        <Pill size={currentSize.icon} color={color} />
      )}
      
      {/* Texto dividido em duas linhas - oculto em tamanho small */}
      {size !== 'small' && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '2px'
        }}>
          <div style={{ 
            fontSize: currentSize.font1, 
            fontWeight: 'bold',
            color: color === '#007bff' ? '#333' : color,
            lineHeight: '1.2'
          }}>
            Farmácia Popular
          </div>
          <div style={{ 
            fontSize: currentSize.font2, 
            fontWeight: 'bold',
            color: color === '#007bff' ? '#333' : color,
            lineHeight: '1.2'
          }}>
            de Minas
          </div>
        </div>
      )}
    </div>
  );
};

export default LogoVertical;